import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from './MetaPixel';
interface CTAButtonProps {
  className?: string;
  href?: string;
}
const SHOPIFY_URL = 'https://www.legadosalud.com/cart/42403374071893:1';
export function CTAButton({
  className = '',
  href = SHOPIFY_URL
}: CTAButtonProps) {
  const handleClick = () => {
    if (href === SHOPIFY_URL) {
      trackAddToCart();
    }
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-12">
      <motion.a href={href} onClick={handleClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="bg-brand-cta hover:bg-brand-ctaHover text-white font-bold text-xl md:text-2xl py-5 px-8 rounded-full shadow-lg transition-colors duration-300 text-center w-full max-w-md" data-id="element-13">
        ¡QUIERO MI MANUAL AHORA!
      </motion.a>
      <p className="mt-3 text-sm text-center opacity-80 font-medium max-w-xs" data-id="element-14">
        Acceso instantáneo para lectura en celular, tableta o computadora.
      </p>
    </div>;
}